// extracted by mini-css-extract-plugin
export default {"failure":"GracefulFailureDemo_failure__u0S1w","topChip":"GracefulFailureDemo_topChip__bzIaR","gap":"GracefulFailureDemo_gap__iaYSg","options":"GracefulFailureDemo_options__YQEbb"};